import React from 'react';
import cx from 'classnames';
import { Switch, useRouteMatch, Redirect, useLocation, Route } from 'react-router-dom';

import {
  HorizontalTabList,
} from 'spindl-shared-components';

import TemplateLibraryPage from '../../pages/TemplateLibraryPage';
import styles from './CommunicationsMainLayout.module.scss';
import usePresenter from './CommunicationsMainLayout.presenter';
import getProps from './CommunicationsMainLayout.props';
import { CommunicationsMainLayoutCombinedProps } from './types';
// import ActivityPage from '../../pages/ActivityPage';

const CommunicationsMainLayout: React.FC<CommunicationsMainLayoutCombinedProps> = (props) => {
  const {
    className,
    classes,
    horizontalTabList,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.communicationsMainLayout;

  const { pathname } = useLocation();
  const { path } = useRouteMatch();
  // const basePath = path === '/' ? '' : path;

  return (
    <div className={cx(currentStyle, className)}>
      <HorizontalTabList
        className={cx(styles.horizontalTabList, classes?.horizontalTabList)}
        {...internalProps.horizontalTabList}
        {...horizontalTabList}
      />
      <Switch>
        <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
        {/* <Route path={`${basePath}/activity`}>
          <ActivityPage className={styles.templateLibraryPage} />
        </Route> */}
        <Route exact path={path}>
          <TemplateLibraryPage className={styles.templateLibraryPage} />
        </Route>
      </Switch>
    </div>
  );
};

export default CommunicationsMainLayout;
